<template>
  <span
    class="c-app-icon"
    :class="{ 'c-app-icon--filled': filled }"
    :style="{ fontSize: `${size}px` }"
    aria-hidden="true"
  >{{ name }}</span>
</template>

<script>
// Material Symbols Rounded — browse names at https://fonts.google.com/icons
export default {
  name: 'AppIcon',
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 20,
    },
    filled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.c-app-icon {
  font-family: 'Material Symbols Rounded';
  font-weight: 400;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  white-space: nowrap;
  direction: ltr;
  display: inline-flex;
  flex-shrink: 0;
  user-select: none;
  -webkit-font-smoothing: antialiased;
  font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
}

.c-app-icon--filled {
  font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;
}
</style>
